import { render, staticRenderFns } from "./HouseholdIncomeRatio.vue?vue&type=template&id=0e8797e9&scoped=true&"
import script from "./HouseholdIncomeRatio.vue?vue&type=script&lang=js&"
export * from "./HouseholdIncomeRatio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8797e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e8797e9')) {
      api.createRecord('0e8797e9', component.options)
    } else {
      api.reload('0e8797e9', component.options)
    }
    module.hot.accept("./HouseholdIncomeRatio.vue?vue&type=template&id=0e8797e9&scoped=true&", function () {
      api.rerender('0e8797e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/HouseholdIncomeRatio.vue"
export default component.exports